import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'jotai';

const TicketJotai = ({ children }) => {
  return <Provider>{children}</Provider>;
};

TicketJotai.propTypes = {};

export default TicketJotai;
